var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMoneyDollar = function SvgMoneyDollar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.929 14.429H21.07A1.43 1.43 0 0 0 22.5 13V4.429A1.432 1.432 0 0 0 21.071 3H3.93A1.432 1.432 0 0 0 2.5 4.429V13a1.432 1.432 0 0 0 1.429 1.429Zm0-10H21.07V13H3.93V4.429Zm6.984 6.66a2.856 2.856 0 1 0 3.174-4.749 2.856 2.856 0 0 0-3.174 4.75Zm.793-3.563a1.429 1.429 0 1 1 1.588 2.377 1.429 1.429 0 0 1-1.588-2.377Zm6.508-.24a1.428 1.428 0 1 0 0 2.857 1.428 1.428 0 0 0 0-2.857Zm-15 8.571h18.572a.714.714 0 1 1 0 1.429H3.214a.714.714 0 0 1 0-1.429Zm0 2.857h18.572a.714.714 0 1 1 0 1.429H3.214a.714.714 0 0 1 0-1.429ZM6.786 7.286a1.429 1.429 0 1 0 0 2.857 1.429 1.429 0 0 0 0-2.857Z",
    fill: "#000"
  })));
};
export default SvgMoneyDollar;